package com.brdgwtr.designsystem.foundation

import androidx.compose.ui.text.font.FontFamily

internal actual val Lato: FontFamily
    get() = FontFamily.Serif // TODO we need to handle fonts for web
